import { render } from "./ExampleBox.vue?vue&type=template&id=bc0c84f4&ts=true"
import script from "./ExampleBox.vue?vue&type=script&lang=ts"
export * from "./ExampleBox.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__